<template>
  <main>
    <div class="row">
      <div class="col-12">
        <div class="tile">
          <div class="form-inline">
            <b-form-input class="mr-1 mb-2" v-model="filterFormModel.keyword" v-on:keydown.enter="load"
                          :placeholder="$t('keyword')"></b-form-input>
            <client-select class="mr-1 mb-2" :model="filterFormModel" attribute="client" @change="search"
                           :isFilter="true" :place-holder="$t('selectClient')"></client-select>
            <sms-brandname-select :model="filterFormModel" attribute="brandName" client-attribute="client" @input="load"
                                  :isFilter="true" class="mr-1 mb-2"/>
            <sms-template-select :model="filterFormModel" attribute="template" client-attribute="client" @input="load"
                                 :isFilter="true" class="mr-1 mb-2"/>
            <form-select :model="filterFormModel" attribute="type" class="mr-1 mb-2" :options="[
              {text: this.$t('type'), value: null},
              {text: this.$t('ads'), value: 'ads'},
              {text: this.$t('care'), value: 'care'},
            ]"></form-select>
            <form-select :model="filterFormModel" attribute="status" class="mr-1 mb-2" :options="[
              {value: null, text: $t('status')},
              {value: 'success', text: $t('success')},
              {value: 'fail', text: $t('error')}
            ]"></form-select>
            <form-select :model="filterFormModel" attribute="timeFilter" class="mr-1 mb-2" :options="[
              {text: this.$t('filterByCreateTime'), value: 'createTime'},
              {text: this.$t('filterBySendTime'), value: 'sendTime'},
            ]"></form-select>
            <time-range-picker :model="filterFormModel" :label="$t('time')" class="mr-1 mb-2"
                               :defaultShortcut="3"></time-range-picker>
            <webhook-vietguys-export :filter="filterFormModel" :total-count="itemCount"/>
            <button @click="load" class="btn btn-primary mr-1 mb-2">{{ $t('search') }}</button>
            <button @click="reset" class="btn btn-secondary mr-1 mb-2">Reset</button>
          </div>
        </div>
      </div>
      <div class="col-12">
        <div class="c-paging clearfix">
          <div class="c-paging__count" v-if="itemCount">
            {{ $t('found', [itemCount]) }}
          </div>
          <div class="c-paging__right">
            <div class="c-paging__numbers">
              <b-pagination v-if="itemCount > filterFormModel.pageSize" class="pull-right" size="sm"
                            v-model="filterFormModel.page" :total-rows="itemCount" :per-page="filterFormModel.pageSize"
                            @input="load"></b-pagination>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12" v-if="items.length">
        <div class="c-smart-table tile">
          <div class="row c-smart-table__title">
            <div class="col-lg-2">{{ $t('from') }}</div>
            <div class="col-lg-2">{{ $t('to') }}</div>
            <div class="col-lg-4">{{ $t('content') }}</div>
            <div class="col-lg-3">{{ $t('time') }}</div>
            <div class="col-lg-1"></div>
          </div>
          <div class="row" v-for="item in items" :key="item._id">
            <div class="col-lg-2">
              <p><b class="c-smart-table__label">{{ $t('from') }}: </b></p>
              <p>
                <b>{{ $t('client') }}: </b>
                <span v-if="item.client">{{ item.client.domain }}</span>
                <span v-else class="text-secondary">{{ $t('unknown') }}</span>
              </p>
              <p v-if="item.messageCampaign"><b>{{ $t('campaign') }}: </b><span>{{ item.messageCampaign.name }}</span>
              </p>
              <p v-if="item.brandName"><b>Brand name: </b><span>{{ item.brandName.name }}</span></p>
              <p v-if="item.gateway"><b>Gateway: </b><span>{{ item.gateway.name }}</span></p>
              <p v-if="item.template"><b>{{ $t('messageTemplate') }}: </b><span>{{ item.template.name }}</span></p>
            </div>
            <div class="col-lg-2">
              <p><b class="c-smart-table__label">{{ $t('to') }}: </b></p>
              <p v-if="item.messageCampaignContact && item.messageCampaignContact.name">
                <b>{{ $t('contactName') }}:&nbsp;</b><span>{{ item.messageCampaignContact.name }}</span>
              </p>
              <p v-if="item.number">
                <b>{{ $t('number') }}:&nbsp;</b><span>{{ item.number }}</span>
              </p>
              <p v-if="item.telco">
                <b>{{ $t('network') }}:&nbsp;</b><span>{{ item.telco }}</span>
              </p>
            </div>
            <div class="col-lg-4">
              <p><b class="c-smart-table__label">{{ $t('content') }}: </b></p>
              <p v-if="item.sms && item.sms.content">{{ item.sms.content }}</p>
              <p>
                <label class="badge"
                       :class="item.type==='ads' ? 'badge-info' : 'badge-primary'">{{ $t(item.type) }}</label>&nbsp;
                <label class="badge badge-danger" v-if="item.status === 'fail'">{{ $t('error') }}</label>
                <label class="badge badge-success" v-else>{{ $t('success') }}</label>
              </p>
              <p v-if="item.total">
                <b>{{ $t('numberOfMessages') }}:&nbsp;</b><span>{{ item.total }}</span>
              </p>
            </div>
            <div class="col-lg-3">
              <p><b class="c-smart-table__label">{{ $t('time') }}: </b></p>
              <p>
                <b>{{ $t('createTime') }}:&nbsp;</b><span>{{ item.createTime | moment('HH:mm:ss DD/MM/YYYY') }}</span>
              </p>
              <p v-if="item.sendTime">
                <b>{{ $t('sendTime') }}:&nbsp;</b><span>{{ item.sendTime | moment('HH:mm:ss DD/MM/YYYY') }}</span>
              </p>
            </div>
            <div class="col-lg-1">
              <div>
                <button @click="showDetailModal(item)" class="btn btn-sm btn-outline-secondary">
                  <i class="fa fa-eye"></i>
                  {{ $t('seeDetail') }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 text-center text-danger" v-if="!items.length">{{ $t('notFoundSearch') }}</div>
      <div class="col-12" v-if="itemCount">
        <div class="c-paging__count" v-if="itemCount">
          {{ $t('found', [itemCount]) }}
        </div>
        <b-pagination v-if="itemCount > filterFormModel.pageSize" class="pull-right" size="sm"
                      v-model="filterFormModel.page" :total-rows="itemCount" :per-page="filterFormModel.pageSize"
                      @input="load">
        </b-pagination>
      </div>
    </div>

    <b-modal v-model="showDetail" size="lg">
      <div>
        <b>Request body</b>
        <div v-if="body" class="mt-1">
          <json-viewer :value="JSON.parse(body)" :expand-depth=1 :boxed=false sort
                       style="background-color: #f8f8fa"></json-viewer>
        </div>
        <div v-else class="text-danger text-center">{{ $t('noData') }}</div>
      </div>
    </b-modal>
  </main>
</template>

<script>
import list from '../../mixins/List';
import ClientSelect from "../../components/ClientSelect.vue";
import TimeRangePicker from "../../components/TimeRangePicker.vue";
import SmsBrandnameSelect from "@/components/SmsBrandnameSelect.vue";
import SmsTemplateSelect from "@/components/SmsTemplateSelect.vue";
import _ from 'lodash';
import JsonViewer from 'vue-json-viewer';
import WebhookVietguysExport from "@/views/webhook-vietguys/WebhookVietguysExport.vue";

export default {
  components: {TimeRangePicker, ClientSelect, SmsBrandnameSelect, SmsTemplateSelect, JsonViewer, WebhookVietguysExport},
  mixins: [list],
  data() {
    return {
      service: '/vietguys-log',
      autoLoad: true,
      defaultFilterFormModel: {
        keyword: null,
        client: null,
        brandName: null,
        template: null,
        type: null,
        status: null,
        timeFilter: 'createTime'
      },
      showDetail: false,
      body: null
    }
  },
  methods: {
    search: _.debounce(function () {
      this.filterFormModel.page = 1;
      this.load();
    }, 200),
    showDetailModal(item) {
      this.body = item.body ? item.body : null
      this.showDetail = true
    }
  },
  i18n: {
    messages: {
      en: {
        from: 'Sent from',
        to: 'Sent to',
        content: 'Content',
        time: 'Time',
        createTime: 'Create time',
        sendTime: 'Send time',
        care: 'Care',
        ads: 'Ads',
        type: 'Type',
        number: 'Number',
        campaign: 'Campaign',
        messageTemplate: 'Message template',
        contactName: 'Contact name',
        filterByCreateTime: 'Filter by creation time',
        filterBySendTime: 'Filter by send time',
        seeDetail: 'See detail',
        noData: 'No data',
        numberOfMessages: 'Number of messages',
      },
      vi: {
        from: 'Gửi từ',
        to: 'Gửi tới',
        content: 'Nội dung',
        time: 'Thời gian',
        createTime: 'Tạo lúc',
        sendTime: 'Gửi lúc',
        care: 'CSKH',
        ads: 'Quảng cáo',
        type: 'Loại',
        number: 'Số điện thoại',
        campaign: 'Chiến dịch',
        messageTemplate: 'Mẫu tin nhắn',
        contactName: 'Tên liên hệ',
        filterByCreateTime: 'Lọc theo thời gian tạo',
        filterBySendTime: 'Lọc theo thời gian gửi',
        seeDetail: 'Xem chi tiết',
        noData: 'Không có dữ liệu',
        numberOfMessages: 'Tổng tin gửi',
      }
    }
  }
}
</script>